const FINISH_SCROLL_BUFFER = 1;

export default function smoothScroll(
  element: any,
  endScrollTop = 0,
  duration = 200,
  easing: 'linear' | 'easeInOutQuad' = 'linear',
  retryTime = 0,
) {
  const easings = {
    linear(t: any) {
      return t;
    },
    easeInOutQuad(t: any) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
  };

  const startTime = new Date().getTime();
  const startScrollTop =
    element === window
      ? element.scrollY || element.pageYOffset
      : element.scrollTop;

  if ('requestAnimationFrame' in window === false) {
    if (element.scrollTo) {
      element.scrollTo(0, endScrollTop);
    } else {
      element.scrollTop = endScrollTop;
    }
    return;
  }

  function scroll() {
    const now = new Date().getTime();
    const time = Math.min(1, (now - startTime) / duration);
    const timeFunction = easings[easing](time);
    const intermediateScrollTop = Math.ceil(
      timeFunction * (endScrollTop - startScrollTop) + startScrollTop,
    );

    if (element.scrollTo) {
      element.scrollTo(0, intermediateScrollTop);
    } else {
      element.scrollTop = intermediateScrollTop;
    }

    // Need buffer for edge case when top and offset are off by a fraction of a px
    if (
      (element.scrollTop === endScrollTop ||
        element.scrollTop + element.offsetHeight + FINISH_SCROLL_BUFFER >=
          element.scrollHeight) &&
      new Date().getTime() - startTime > retryTime
    ) {
      return;
    }

    // Need buffer for edge case when top and offset are off by a fraction of a px
    if (
      element === window &&
      Math.abs((element.scrollY || element.pageYOffset) - endScrollTop) <
        FINISH_SCROLL_BUFFER &&
      new Date().getTime() - startTime > retryTime
    ) {
      return;
    }

    // Scroll to the last div, avoid fitting the gap between element.pageYOffset
    // and endScrollTop, this fixes infinte scrolling calls
    if (
      !process.env.SSR &&
      element.innerHeight + element.pageYOffset >=
        window.document.body.scrollHeight &&
      new Date().getTime() - startTime > retryTime
    ) {
      return;
    }
    requestAnimationFrame(scroll);
  }

  scroll();
}
